import { MetaConversation } from 'lib-shared-legacy-types';

import type { PhoneNumber } from 'apis/numbers';

export function canConversationTransferToAgent(
  metaConversation: MetaConversation,
): boolean {
  const {
    conversation: {
      direction,
      status,
      initial_channel: initialChannel,
      live_assesment: liveAssessment,
    },
    isAssignedToMe,
  } = metaConversation;

  if (direction === 'internal') return true;
  if (status !== 'open') return false;
  if (!isAssignedToMe) return false;

  // For synchronous channels, only allow transfer to agent if the enduser is connected.
  if (
    ['pstnphone', 'widgetchat', 'messenger'].includes(
      initialChannel as string,
    ) &&
    liveAssessment &&
    liveAssessment.is_end_user_connected === false
  ) {
    return false;
  }

  if (initialChannel === 'callback') return false;

  return true;
}

export function canConversationTransferToQueue(
  metaConversation: MetaConversation,
  latestMessengerConversation: number | null,
): boolean {
  const {
    conversation: {
      direction,
      status,
      assignment,
      id: csid,
      initial_channel: initialChannel,
    },
    isAssignedToMe,
  } = metaConversation;

  let transferToQueueDisabled = false;

  if (direction !== 'internal') {
    if (
      status === 'closed' ||
      status === 'awaitingpending' ||
      status === 'pending'
    ) {
      transferToQueueDisabled = false;
    }

    if (isAssignedToMe === false) {
      transferToQueueDisabled = true;
    }

    // BUT we do allow "transfer to queue" if it not assigned to ourselves and it's not assisted to anyone.
    if (isAssignedToMe === false && assignment === null) {
      transferToQueueDisabled = false;
    }

    if (
      (isAssignedToMe === false && status === 'closed') ||
      status === 'awaitingpending' ||
      status === 'pending'
    ) {
      transferToQueueDisabled = false;
    }

    if (status === 'closed') {
      if (initialChannel === 'whatsapp') {
        transferToQueueDisabled = true;
      }

      if (initialChannel === 'facebookmessenger') {
        if ((csid ?? -1) < (latestMessengerConversation ?? 0)) {
          transferToQueueDisabled = true;
        }
      }
    }
  }

  return !transferToQueueDisabled;
}

export function canConversationTransferToNumber(
  metaConversation: MetaConversation,
  staticTelephoneNumbers: PhoneNumber[],
): boolean {
  const {
    conversation: {
      direction,
      status,
      initial_channel: initialChannel,
      live_assesment: liveAssessment,
    },
    isAssignedToMe,
  } = metaConversation;

  let transferToNumberDisabled = true;

  if (direction !== 'internal') {
    // Only allow blind/assisted transfer on phone conversations and callbacks.
    if (initialChannel === 'pstnphone') {
      transferToNumberDisabled = false;
    }

    if (
      status === 'closed' ||
      status === 'awaitingpending' ||
      status === 'pending'
    ) {
      transferToNumberDisabled = true;
    }

    if (isAssignedToMe === false) {
      transferToNumberDisabled = true;
    }

    // We do not allow transfer to number if the enduser not is connected and the conversation not is an email.
    if (
      initialChannel !== 'email' &&
      liveAssessment &&
      liveAssessment.is_end_user_connected === false
    ) {
      transferToNumberDisabled = true;
    }

    if (status === 'closed') {
      if (initialChannel === 'whatsapp') {
        transferToNumberDisabled = true;
      }
    }
  }

  return !transferToNumberDisabled;
}
